<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('messages.donate') }}</h1>
      <div class="card__description">
        <div class="mb-3">
          <p>{{ $t('messages.donate_text') }}</p>
          <br />
          <p>{{ $t('messages.donate_thanks') }}</p>
        </div>
        <div class="d-flex justify-content-center mb-3 ">
          <div class="d-flex align-items-center p-3">
            <div class="full-width">
              <b-button v-for="value in possibleValues" :key="value" class="donate__button"
                        @click="currentValue = value" :variant="currentValue === value ? 'primary' : 'secondary'">€ {{ value }}</b-button>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-3 ">
          <div class="d-flex card__payment__width align-items-center round-border-red p-3">
            <div class="full-width">
              <p>{{ name }}</p>
              <p>{{ iban }}</p>
              <p>{{ bic }}</p>
            </div>
            <div class="d-flex align-items-center card__payment__code">
              <qrcode :value="qrCode" :options="{ width: 100 }"></qrcode>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-3">
          <div class="d-flex card__payment__width align-items-center round-border-red p-3">
            <div class="full-width">
              <p>{{ name }}</p>
              <p>{{ paypal }}</p>
            </div>
            <div class="card__payment__code">
              <p><a :href="payPalMe" target="_blank"><font-awesome-icon :icon="['fab', 'cc-paypal']" size="4x"></font-awesome-icon></a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qrcode from '@chenfengyuan/vue-qrcode/src/index'

export default {
  name: 'donate',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.donate') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.donate'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  components: { Qrcode },
  data: function () {
    return {
      name: 'CrowdFinder',
      iban: 'BE92 7360 5977 7023',
      bic: 'KRED BE BB',
      paypal: 'info@crowdfinder.be',
      paypalMe: 'crowdf',
      possibleValues: [1, 2, 5, 10, 20],
      currentValue: null
    }
  },
  computed: {
    qrCode: function () {
      return 'BCD\n001\n1\nSCT\n' + this.bic + '\n' + this.name + '\n' + this.iban + '\nEUR' + this.currentValue + '\n\n\n' + 'Donatie CF'
    },
    payPalMe: function () {
      return 'https://www.paypal.me/' + this.paypalMe + '/EUR' + this.currentValue
    }
  },
  created: function () {
    this.currentValue = this.possibleValues[2]
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .donate__button {
    width: 60px;
    margin-right: 5px;
  }

  .card__payment__width {
    min-width: 350px;
  }

  .card__payment__code {
    min-width: 100px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Donate.vue